import { tw } from '@/utils/tw';
import BaseSkeletonTheme from 'base/components/Skeleton/theme';

const Skeleton = tw.theme({
  extend: BaseSkeletonTheme,
  base: `bg-gray-50`,
});

export default Skeleton;
